import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUpIcon, SmartphoneIcon, BarChart3Icon } from 'lucide-react';
const articles = [{
  id: 1,
  title: 'Gold Prices Hit New Highs: What Investors Need to Know',
  excerpt: 'Discover the factors driving gold prices to record levels and what this means for precious metals portfolio.',
  category: 'Market Analysis',
  date: 'December 15, 2023',
  icon: <TrendingUpIcon className="w-10 h-10" data-id="element-228" />,
  color: 'bg-blue-500'
}, {
  id: 2,
  title: 'Refurbished vs New: Making the Smart Tech Choice',
  excerpt: 'Learn why certified refurbished electronics offer the best balance of quality, sustainability, and value.',
  category: 'Technology',
  date: 'December 12, 2023',
  icon: <SmartphoneIcon className="w-10 h-10" data-id="element-229" />,
  color: 'bg-green-500'
}, {
  id: 3,
  title: 'Silver Investment Guide: 2023 Market Outlook',
  excerpt: "Explore expert's industrial applications and investment potential of silver with comprehensive market analysis.",
  category: 'Investment',
  date: 'December 10, 2023',
  icon: <BarChart3Icon className="w-10 h-10" data-id="element-230" />,
  color: 'bg-purple-500'
}];
export const LatestInsights: React.FC = () => {
  return <section className="py-12 bg-gray-50 dark:bg-gray-800" data-id="element-231">
      <div className="container mx-auto px-4" data-id="element-232">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 dark:text-white mb-4" data-id="element-233">
          Latest Industry Insights
        </h2>
        <p className="text-center text-gray-600 dark:text-gray-400 max-w-2xl mx-auto mb-10" data-id="element-234">
          Stay informed with our latest articles on technology trends, market
          analysis, and precious metals investment strategies.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-235">
          {articles.map(article => <div key={article.id} className="bg-white dark:bg-gray-900 rounded-lg overflow-hidden shadow-md" data-id="element-236">
              <div className={`${article.color} p-6 flex justify-center items-center text-white`} data-id="element-237">
                {article.icon}
              </div>
              <div className="p-6" data-id="element-238">
                <div className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1" data-id="element-239">
                  {article.category}
                </div>
                <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2" data-id="element-240">
                  {article.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-4" data-id="element-241">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between" data-id="element-242">
                  <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-243">
                    {article.date}
                  </span>
                  <Link to="#" className="text-sm font-medium text-yellow-500 hover:text-yellow-600" data-id="element-244">
                    Read more
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
        <div className="text-center mt-8" data-id="element-245">
          <Link to="/blog" className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-yellow-500 hover:bg-yellow-600" data-id="element-246">
            View All Articles
          </Link>
        </div>
      </div>
    </section>;
};